import React from "react";

export const UserContext = React.createContext({ test: true });

export const ListingContext = React.createContext({ test: true });

export const ApplyContext = React.createContext({ test: true });



// WEBPACK FOOTER //
// ./src/Context.js